export const ADD_DECLARATION = 'ADD_DECLARATION';
export const addDeclaration = (newDeclaration) => ({
  type: ADD_DECLARATION,
  payload: {
    newDeclaration,
  },
});

export const REMOVE_DECLARATION = 'REMOVE_DECLARATION';
export const removeDeclaration = (declarationKey, generateDeclaration) => ({
  type: REMOVE_DECLARATION,
  payload: {
    declarationKey,
    generateDeclaration,
  },
});

export const UPDATE_DECLARATION = 'UPDATE_DECLARATION';
export const updateDeclaration = (declarationKey, updatedPayload) => ({
  type: UPDATE_DECLARATION,
  payload: {
    declarationKey,
    updatedPayload,
  },
});

export const UPDATE_CONTENT_TYPE = 'UPDATE_CONTENT_TYPE';
export const updateContentType = (contentType) => ({
  type: UPDATE_CONTENT_TYPE,
  payload: {
    contentType,
  },
});

export const UPDATE_DUTIES_PAID = 'UPDATE_DUTIES_PAID';
export const updateDutiesPaid = (dutiesPaid) => ({
  type: UPDATE_DUTIES_PAID,
  payload: {
    dutiesPaid,
  },
});

export const UPDATE_POSTAGE_PAID = 'UPDATE_POSTAGE_PAID';
export const updatePostagePaid = (postagePaid) => ({
  type: UPDATE_POSTAGE_PAID,
  payload: {
    postagePaid,
  },
});

export const UPDATE_NON_DELIVERY = 'UPDATE_NON_DELIVERY';
export const updateNonDelivery = (nonDelivery) => ({
  type: UPDATE_NON_DELIVERY,
  payload: {
    nonDelivery,
  },
});

export const UPDATE_ITN_OR_EXEMPTION = 'UPDATE_ITN_OR_EXEMPTION';
export const updateItnOrExemption = (exemptionCodeOrITN) => ({
  type: UPDATE_ITN_OR_EXEMPTION,
  payload: {
    exemptionCodeOrITN,
  },
});

export const UPDATE_EXPORT_DECLARATION_NUMBER = 'UPDATE_EXPORT_DECLARATION_NUMBER';
export const updateExportDeclarationNumber = (exportDeclarationNumber) => ({
  type: UPDATE_EXPORT_DECLARATION_NUMBER,
  payload: {
    exportDeclarationNumber,
  },
});

export const UPDATE_INVOICE_NUMBER = 'UPDATE_INVOICE_NUMBER';
export const updateInvoiceNumber = (invoiceNumber) => {
  return {
    type: UPDATE_INVOICE_NUMBER,
    payload: {
      invoiceNumber,
    },
  };
};
export const UPDATE_IMPORTER_OF_RECORD = 'UPDATE_IMPORTER_OF_RECORD';
export const updateImporterOfRecord = (importerOfRecord) => {
  return {
    type: UPDATE_IMPORTER_OF_RECORD,
    payload: {
      importerOfRecord,
    },
  };
};
